module.exports = __webpack_public_path__ + "img/cpzz16@2x.2afeef79.png";